import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
import {
  Badge,
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  getShortcutDescription,
  MenuItemBase,
} from "../../../components/layout/navMenu";

interface HubShortcutGridProps {
  shortcuts: MenuItemBase[];
  badges?: Record<string, number>;
}

const HubShortcutGrid: React.FC<HubShortcutGridProps> = ({
  shortcuts,
  badges,
}) => {
  const navigate = useNavigate();

  return (
    <Grid container spacing={1.25}>
      {shortcuts.map((item) => {
        const badgeCount = item.path ? badges?.[item.path] ?? 0 : 0;
        return (
          <Grid item xs={12} sm={6} key={item.path ?? item.text}>
            <Card
              variant="outlined"
              sx={{
                borderRadius: 1.5,
                transition: "border-color 0.15s, box-shadow 0.15s",
                "&:hover": {
                  borderColor: "primary.main",
                  boxShadow: 1,
                },
              }}
            >
              <CardActionArea
                onClick={() => item.path && navigate(item.path)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.25,
                    py: 1.25,
                    px: 1.5,
                    width: "100%",
                    "&:last-child": { pb: 1.25 },
                  }}
                >
                  <Badge
                    badgeContent={badgeCount > 0 ? badgeCount : 0}
                    color="error"
                    max={99}
                    invisible={badgeCount <= 0}
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.65rem",
                        height: 16,
                        minWidth: 16,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        flexShrink: 0,
                        borderRadius: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "rgba(0, 102, 178, 0.08)",
                        color: "primary.main",
                        "& .MuiSvgIcon-root": { fontSize: "1.1rem" },
                      }}
                    >
                      {item.icon}
                    </Box>
                  </Badge>
                  <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, lineHeight: 1.3 }}
                    >
                      {item.text}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block", lineHeight: 1.3 }}
                    >
                      {getShortcutDescription(item)}
                    </Typography>
                  </Box>
                  <ArrowForwardIcon
                    sx={{
                      fontSize: "0.95rem",
                      color: "text.disabled",
                      flexShrink: 0,
                    }}
                  />
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default HubShortcutGrid;
